import React from 'react';
import { CommonWidgetContainer } from './commonWidgetStyle';
import RadarMapWidgetBody from './radarMapWidgetBody';
import { CommonWidgetHeader } from './commonWidgetHeader';
import { translate } from '../../../common/translation/translate';
import { WidgetProps } from '../interfaces/types';
import { getWidgetHeaderText } from '../../../common/utilities/getWidgetHeaderUtil';

export const RadarMapWidgetDesktopTablet = ({ widgetLinkURL, enableMapsPageOnWeb2 }: WidgetProps & { enableMapsPageOnWeb2: boolean; }): JSX.Element => {
    if (enableMapsPageOnWeb2) {
        return (
            <CommonWidgetContainer href={widgetLinkURL} target='_self' title='Explore Live Weather Radar Map for precipitation Forecasts'> 
                <CommonWidgetHeader headerText={getWidgetHeaderText({ widgetTitle: translate('liveRadar') })} />
                <RadarMapWidgetBody />
            </CommonWidgetContainer>
        );
    }
    return (
        <CommonWidgetContainer href={widgetLinkURL} title='Explore Live Weather Radar Map for precipitation Forecasts'> 
            <CommonWidgetHeader headerText={getWidgetHeaderText({ widgetTitle: translate('liveRadar') })} />
            <RadarMapWidgetBody />
        </CommonWidgetContainer>
    );
};

RadarMapWidgetDesktopTablet.displayName = 'RadarMapWidgetDesktopTablet';
